import React from 'react'
import './form.css'
import moment from 'moment'

const DetailModal = ({ data }) => {
    return (
        <div className="appraisal-report-table-responsive">
            <table className="headr-table bg-grd" cellSpacing={0}>
                <tbody>
                    <tr style={{ height: "23pt" }}>
                        <td>
                            <p className="s1">
                                Name: <span>{data.FULL_NAME}</span>
                            </p>
                        </td>
                        <td>
                            <p className="s1">
                                Designation: <span>{data.DESIGNATION_NAME}</span>
                            </p>
                        </td>
                        <td>
                            <p className="s1">
                                Date of Report: <span>{moment(data.DATE_OF_REPORT).format('DD MMM, YYYY')}</span>
                            </p>
                        </td>
                    </tr>
                    <tr style={{ height: "22pt" }}>
                        <td>
                            <p className="s1">
                                Site Office: <span>{data.SITE_LOCATION_NAME}</span>
                            </p>
                        </td>
                        <td colSpan={2}>
                            <p className="s1">
                                Owner &amp; Hull No: <span>{data.OWNER_NAME} - {data.HULL_NUMBER}</span>
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="assessment-table" cellSpacing={0}>
                <tbody>
                    <tr style={{ height: "28pt" }}>
                        <td className="hd-s1" colSpan={5}>
                            <p>ASSESSMENT</p>
                        </td>
                        <td className="hd-s2">
                            <p>
                                <a name="bookmark0">‌</a>Appraiser’s
                                <br /> Evaluation <br />
                                (1 to 5)<a name="bookmark1">‌</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-s1">
                            <p className="s1">1.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Knowledge and Skill:</p>
                            <p className="s2">
                                Has adequate knowledge and skills to perform the job
                                properly
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.KNOWLEDGE_SKILL}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="td-s1">
                            <p className="s1">2.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Application of Knowledge &amp; Skills:</p>
                            <p className="s3">
                                Committed to ensure compliance of Technical Specification,
                                Approved Drawings/ its approval comments.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.APPLICATION_OF_KNOWLEDGE}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">3.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">
                                Leadership &amp; Sense of Responsibility:
                            </p>
                            <p className="s3">
                                Motivates and leads by example, is able to make rational
                                decisions and can be depended upon.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.LEADERSHIP_RESPONSIBILITY}
                            />
                        </td>
                    </tr>
                    <tr style={{ height: "34pt" }}>
                        <td className="td-s1">
                            <p className="s1">4.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Teamwork:</p>
                            <p className="s3">
                                Works well with others in an enthusiastic manner, assists,
                                cooperates &amp; shares information with colleagues.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.TEAMWORK}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "23pt" }}>
                        <td className="td-s1">
                            <p className="s1">5.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Initiative &amp; Motivation:</p>
                            <p className="s3">
                                Willing to take additional responsibility. Strongly
                                motivated to do the job well.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.INITIATIVE_MOTIVATION}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "26pt" }}>
                        <td className="td-s1">
                            <p className="s1">6.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Communication and Interpersonal Skills:</p>
                            <p className="s3">
                                Ability to listen &amp; express oneself clearly and
                                effectively.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.COMMUNICATION_SKILLS}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "34pt" }}>
                        <td className="td-s1">
                            <p className="s1">7.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">
                                Attitude towards Safety, Health &amp; Environment:
                            </p>
                            <p className="s3">
                                Takes interest in Company’s QHSE system and follows safe
                                working practices at all times.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.SAFETY_ATTITUDE}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "34pt" }}>
                        <td className="td-s1">
                            <p className="s1">8.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">
                                Planning, Organizing &amp; Delegating Skills :
                            </p>
                            <p className="s3">
                                Sets clear goals, makes plans in advance, delegates tasks
                                appropriately and ensures they are completed within the
                                stipulated time.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.PLANNING_ORGANIZING}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">9.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">
                                Ability to Prioritize Tasks/ Time Management:
                            </p>
                            <p className="s3">
                                Has understanding of critical versus non critical tasks,
                                sets priorities for work/ activities.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.PRIORITIZING_TIME_MGMT}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "34pt" }}>
                        <td className="td-s1">
                            <p className="s1">10.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">
                                Problem Solving and Rational Thinking Ability:
                            </p>
                            <p className="s3">
                                Ability to analyze situation logically, identifies possible
                                causes and develops workable solutions.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.PROBLEM_SOLVING}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "34pt" }}>
                        <td className="td-s1">
                            <p className="s1">11.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">
                                Emergency Response / Behavior under Stress:
                            </p>
                            <p className="s3">
                                Copes well with work pressures, is attentive to changes and
                                quick to respond in an emergency situation.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.EMERGENCY_RESPONSE}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "34pt" }}>
                        <td className="td-s1">
                            <p className="s1">12.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Ability to Self Learn:</p>
                            <p className="s3">
                                Takes keen interest in upgrading skills by reading ,
                                observing and is able to learn from own / others experience.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.SELF_LEARNING}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "24pt" }}>
                        <td className="td-s1">
                            <p className="s1">13.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Personal Conduct:</p>
                            <p className="s3">General Appearance, Manners and Conduct.</p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.PERSONAL_CONDUCT}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "26pt" }}>
                        <td className="td-s1">
                            <p className="s1">14.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Interaction with Client/Owner/Builder :</p>
                            <p className="s3">Gives a favourable impression</p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.INTERACTION_WITH_CLIENTS}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "34pt" }}>
                        <td className="td-s1">
                            <p className="s1">15.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Proactive Approach :</p>
                            <p className="s3">
                                Acting in advance to deal with an expected difficulty &amp;
                                takes good anticipatory action
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.PROACTIVE_APPROACH}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">16.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Budgeting / Cost Control :</p>
                            <p className="s3">
                                Understands relationship between cost control and
                                efficiency.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.BUDGETING_COST_CONTROL}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">17.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Focused &amp; Result Oriented:</p>
                            <p className="s3">
                                Has a consistent approach to achieve the most optimum result
                                with available resources.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.RESULT_ORIENTED}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">18.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Rules, Regulations:</p>
                            <p className="s3">
                                Good understanding of regulations and requirements for
                                compliance with regulations
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.RULES_REGULATIONS_COMPLIANCE}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">19.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Document Control:</p>
                            <p className="s3">
                                Ability to document observations systematically and its
                                follow up.
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.DOCUMENT_CONTROL}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">20.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Suitability for promotion to next rank:</p>
                            <p className="s3">
                                Capable of shouldering more responsibility
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.PROMOTION_SUITABILITY}

                            />
                        </td>
                    </tr>
                    <tr style={{ height: "35pt" }}>
                        <td className="td-s1">
                            <p className="s1">21.</p>
                        </td>
                        <td className="td-s2" colSpan={4}>
                            <p className="s1">Recommended for future employment</p>
                            <p className="s3">
                                He can be hired for next available newbiulding project of
                                OSS
                            </p>
                        </td>
                        <td className="td-s3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={data.FUTURE_EMPLOYMENT_RECOMMENDATION}

                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="gard-table">
                <tbody>
                    <tr className="gard-row">
                        <td>
                            <p className="s4">Grade</p>
                        </td>
                        <td>
                            <p className="s4">Poor</p>
                        </td>
                        <td>
                            <p className="s4">Average</p>
                        </td>
                        <td>
                            <p className="s4">Good</p>
                        </td>
                        <td>
                            <p className="s4">Very Good</p>
                        </td>
                        <td>
                            <p className="s4">Exceptionally Good</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="siganture-table" cellSpacing={0}>
                <tbody>
                    <tr className="sig-tr1-box">
                        <td colSpan={3}>
                            <p className="s1">
                                (1) Comments of Person carrying out Appraisal
                                (Site Manager)
                                <br/>
                                {data.SITE_MANAGER_COMMENTS}
                            </p>
                        </td>
                        <td>
                            <p>
                                <br />
                            </p>
                        </td>
                    </tr>
                    <tr className="sig-tr2-box">
                        <td className="w400">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="w300">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.SITE_MANAGER_NAME}

                                />
                            </p>
                            <p className="s2">Name</p>
                        </td>
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td pdr-30">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.SITE_MANAGER_SIGNATURE}

                                />
                            </p>
                            <p className="s2">Signature</p>
                        </td>
                    </tr>
                    <tr className="sig-tr1-box">
                        <td colSpan={3}>
                            <p className="s1">
                                (2) Comments of Person carrying out the Appraisal Review
                                (Project Manager)
                                <br/>
                                {data.PROJECT_MANAGER_COMMENTS}
                            </p>
                        </td>
                        <td>
                            <p>
                                <br />
                            </p>
                        </td>
                    </tr>
                    <tr className="sig-tr2-box">
                        <td className="w400">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="w300">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.PROJECT_MANAGER_NAME}

                                />
                            </p>
                            <p className="s2">Name</p>
                        </td>
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td pdr-30">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.PROJECT_MANAGER_SIGNATURE}

                                />
                            </p>
                            <p className="s2">Signature</p>
                        </td>
                    </tr>
                    {/* <tr className="sig-tr1-box">
                        <td colSpan={3}>
                            <p className="s1">(3) Comments of Office In-charge</p>
                            <br/>
                            {data.OFFICE_INCHARGE_COMMENTS}
                        </td>
                        <td>
                            <p>
                                <br />
                            </p>
                        </td>
                    </tr> */}
                    {/* <tr className="sig-tr2-box">
                        <td className="w400">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="w300">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.OFFICE_INCHARGE_NAME}

                                />
                            </p>
                            <p className="s2">Name</p>
                        </td>
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td pdr-30">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.OFFICE_INCHARGE_SIGNATURE}

                                />
                            </p>
                            <p className="s2">Signature</p>
                        </td>
                    </tr> */}
                    <tr className="sig-tr1-box">
                        <td colSpan={4}>
                            <p className="s1" />
                        </td>
                        <td>
                            <p>
                                <br />
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr className="sig-tr2-box">
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.DATE}

                                />
                            </p>
                            <p className="s2">Date</p>
                        </td>
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.APPRAISEE_SIGNATURE}

                                />
                            </p>
                            <p className="s2">Appraisee’s Signature</p>
                        </td>
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.APPRAISER_NAME}

                                />
                            </p>
                            <p className="s2">Appraiser</p>
                        </td>
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                        <td className="input-td">
                            <p className="s1">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={data.APPRAISER_SIGNATURE}

                                />
                            </p>
                            <p className="s2">Signature</p>
                        </td>
                        <td className="w50">
                            <p>
                                <br />
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

    )
}

export default DetailModal